export var DisabledUI;
(function (DisabledUI) {
    DisabledUI["FromToken"] = "fromToken";
    DisabledUI["ToToken"] = "toToken";
    DisabledUI["FromAmount"] = "fromAmount";
    DisabledUI["ToAddress"] = "toAddress";
})(DisabledUI || (DisabledUI = {}));
